import { useReverseTakedown } from "@/lib/api/risk-flagging";
import { useCan } from "@/lib/casl/use-can";
import { useFeatureFlagEnabled } from "@posthog/react";
import { Link } from "@tanstack/react-router";
import { ExternalLinkIcon, Loader2 } from "lucide-react";

interface TakedownActionsProps {
  alertId?: string;
  onReverseClick?: () => void;
  onReversed?: () => void;
  hideViewLink?: boolean;
}

export function TakedownActions({
  alertId,
  onReverseClick,
  onReversed,
  hideViewLink,
}: TakedownActionsProps) {
  const can = useCan();
  const reverseEnabled = useFeatureFlagEnabled("content-takedown-reversal");
  const reverseTakedown = useReverseTakedown();
  const canReverse = can("update", "content-moderation");
  const canViewRiskFlag = can("read", "risk-flagging");

  const handleReverse = () => {
    if (!alertId) return;
    onReverseClick?.();
    reverseTakedown.mutate({ alertId }, { onSuccess: onReversed });
  };

  return (
    <>
      {reverseEnabled && canReverse && alertId && (
        <button
          type="button"
          onClick={handleReverse}
          disabled={reverseTakedown.isPending}
          className="mt-1 flex items-center gap-1 text-xs font-medium text-blue-600 hover:underline disabled:opacity-50"
        >
          {reverseTakedown.isPending && (
            <Loader2 className="h-3 w-3 animate-spin" />
          )}
          Reverse takedown
        </button>
      )}
      {!hideViewLink && canViewRiskFlag && alertId && (
        <Link
          to="/risk-flagging"
          search={{ alertId }}
          className="flex items-center gap-1 text-xs font-medium text-zinc-500 hover:underline"
        >
          <ExternalLinkIcon className="h-3 w-3" />
          View risk flag
        </Link>
      )}
    </>
  );
}
